import useApi from '../useApi';
import { useShowToast } from '../useShowToast';

export const useFetchGlobalConfigs = () => {
  const showToast = useShowToast();

  const {
    data: configsRes,
    loading: configsLoading,
    error: configsError,
    postData: getGlobalConfigs,
  } = useApi('/Common/basicconfigurations');

  const fetchGlobalConfigs = async () => {
    const res = await getGlobalConfigs();
    if (res?.status === true && res?.errorCode !== '407') {
      return res.data;
    } else {
      showToast(res.message, 'error');
      return [];
    }
  };

  return { configsRes, configsLoading, configsError, fetchGlobalConfigs };
};
export const useFetchDSPConfigs = () => {
  const showToast = useShowToast();

  const {
    data: dspConfigsRes,
    loading: dspConfigsLoading,
    error: dspConfigsError,
    postData: getDSPConfig,
  } = useApi('/Common/configurations');

  const fetchDSPConfig = async (body) => {
    const res = await getDSPConfig(body);
    if (res?.status === true && res?.errorCode !== '407') {
      return res.data;
    } else {
      showToast(res.message, 'error');
      return [];
    }
  };

  return { dspConfigsError, dspConfigsLoading, dspConfigsRes, fetchDSPConfig };
};
